import checkout from "./form";

const {
  formField: {
    // tag page
    title,
    parents,
    top,
    type,
    interests,
    disclaimer,
    persona,
    icon,
    // messageBoxCategoryId,
  },
} = checkout;

const initialValues = {
  // information page
  [title.name]: "",
  [parents.name]: [],
  [top.name]: false,
  [type.name]: { label: "Recommendations", value: "RECOMMENDATIONS" },
  [interests.name]: [],
  [disclaimer.name]: "",
  [persona.name]: [],
  [icon.name]: "",
};

export default initialValues;
